<template>
  <vs-popup class="add-otif-target" id="popup" :title="isCreateMode ? 'ADD OTIF TARGET' : 'UPDATE OTIF TARGET'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-otif-target-popup" @submit.prevent="handleSubmit(onClickCreateTarget)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.formulation_type"
                  :options="['powder', 'liquid', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="region" name="region" rules="required" v-slot="{ errors }">
                <small class="label">Region</small>
                <v-select name="region" :closeOnSelect="true" v-model="form.region"
                  :options="['Great Britain', 'Europe', 'ROW']" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="target" name="target" rules="required|target_integer" v-slot="{ errors }">
                <small class="label">Target (%)</small>
                <vs-input
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  @keypress="onlyWholeNumbers($event)"
                  v-model="form.target"
                  name="target"
                  class="w-full"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-otif-target-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="resetForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const OtifTargetRepository = RepositoryFactory.get('otif_target');
import vSelect from 'vue-select'
import { extend } from 'vee-validate'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

// Custom integer validation rule for OTIF target (no decimals, whole number 0-100)
extend('target_integer', {
  validate: (value) => {
    if (value === null || value === undefined || value === '') return false
    const str = String(value).trim()
    if (!/^\d+$/.test(str)) return false
    const num = Number(str)
    return num >= 0 && num <= 100
  },
  message: 'Target must be a whole number between 0 and 100 without decimals'
})

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      target: '',
      formulation_type: '',
      region: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewOtifTargetPopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    onlyWholeNumbers(event) {
      if (['.', ',', '-', '+', 'e', 'E'].includes(event.key)) {
        event.preventDefault()
      }
    },
    resetForm() {
      const savedFgType = this.form.formulation_type;
      const savedRegion = this.form.region;
      this.form.target = '';
      this.form.formulation_type = savedFgType;
      this.form.region = savedRegion;
    },
    async openPopup(id, fg_type, region, target = '') {
      try {
        Object.assign(this.$data, initialState());
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
        this.open = true;
        this.form.formulation_type = fg_type;
        this.form.region = region;
        if (target !== '' && target !== null && target !== undefined) {
          this.form.target = target;
        }
        if (!!id) {
          this.id = id;
          this.isCreateMode = false;
        } else {
          this.isCreateMode = true;
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async onClickCreateTarget() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-otif-target-popup',
        scale: 0.45
      })
      try {
        const payload = {
          formulation_type: (this.form.formulation_type || '').toLowerCase(),
          region: this.form.region,
          target: parseInt(this.form.target, 10)
        }
        if (this.isCreateMode) {
          await OtifTargetRepository.createOtifTarget(payload);
          this.showSuccessMessage('OTIF target added!');
        } else {
          await OtifTargetRepository.updateOtifTarget(this.id, payload);
          this.showSuccessMessage('OTIF target updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close('#create-otif-target-popup > .con-vs-loading')
      }
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-otif-target>>>.vs-popup {
  min-width: 30% !important;
}
</style>
